import _ from "lodash";
import logger from "./logger";

// 出題数
const totalCount = 10;

class QuizModel {
  constructor() {}

  init(loadedQuizData) {
    if (this.allQuizData) {
      logger.warn("[QuizModel] already initialized");
      return;
    }
    this.allQuizData = loadedQuizData;
    this.renew();
  }

  get isInitialized() {
    return this.allQuizData !== undefined;
  }

  renew() {
    this.quizData = _.shuffle(this.allQuizData).slice(0, totalCount);
    // test
    // this.quizData = [this.allQuizData[20], this.allQuizData[2]]

    this.currentOrder = 1;
    this.correctness = {};
  }

  getTotalCount() {
    return totalCount;
  }

  getCorrectCount() {
    return _.sum(_.values(this.correctness));
  }

  getCorrectPercent() {
    return parseInt((this.getCorrectCount() / totalCount) * 100);
  }

  getCurrentOrder() {
    return this.currentOrder;
  }

  getDataByOrder(order) {
    if (this.quizData[order - 1]) return this.quizData[order - 1];
    else return {};
  }

  incrementOrder() {
    if (this.currentOrder === totalCount) return false;
    this.currentOrder++;
    return true;
  }

  get isLastQuiz() {
    return this.currentOrder === totalCount;
  }

  recordCorrectness(correct) {
    this.correctness[this.currentOrder] = correct ? 1 : 0;
  }
}

export default new QuizModel();
